import { convertMonth } from '@/helpers/convertMonth'
import classNames from 'classnames'
import React from 'react'

import s from './Calendar.module.scss'

const CalendarSliderHead = ({ today, prevMonth, nextMonth }) => {
    return (
        <>
            <div className='container'>
                <div className='calendar__dates-head'>
                    <span className='calendar__dates-month'>
                        {convertMonth(today.format('MMMM'), false)}, {today.format('YYYY')}
                    </span>
                    <div className='calendar__dates-nav'>
                        <button
                            onClick={prevMonth}
                            className='calendar__dates-arrow'
                        >
                            <svg
                                width='20'
                                height='20'
                                viewBox='0 0 20 20'
                                fill='none'
                                xmlns='http://www.w3.org/2000/svg'
                            >
                                <path
                                    d='M12 6L8.05905 10.4336C8.02538 10.4715 8.02538 10.5285 8.05905 10.5664L12 15'
                                    stroke='#A9B4D1'
                                    strokeWidth='2'
                                    strokeLinecap='round'
                                />
                            </svg>
                        </button>
                        <button
                            onClick={nextMonth}
                            className='calendar__dates-arrow'
                        >
                            <svg
                                width='20'
                                height='20'
                                viewBox='0 0 20 20'
                                fill='none'
                                xmlns='http://www.w3.org/2000/svg'
                            >
                                <path
                                    d='M9 15L12.9409 10.5664C12.9746 10.5285 12.9746 10.4715 12.9409 10.4336L9 6'
                                    stroke='#A9B4D1'
                                    strokeWidth='2'
                                    strokeLinecap='round'
                                />
                            </svg>
                        </button>
                    </div>
                </div>
            </div>
        </>
    )
}

export default CalendarSliderHead
